import clsx from "clsx";
import { CSSProperties, MouseEvent, PropsWithChildren } from "react";
import IcoSpinner from "src/assets/IcoSpinner";

interface GradientButton2Props extends PropsWithChildren {
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

export default function GradientButton2({
  onClick,
  isLoading,
  disabled,
  children,
  className,
  style,
}: GradientButton2Props) {
  return (
    <button
      onClick={isLoading ? () => {} : onClick}
      disabled={disabled}
      className={clsx(
        "flex h-full w-full cursor-pointer items-center justify-center rounded-lg bg-[linear-gradient(85deg,#0030AC_-1.07%,#9822F4_99.12%)] px-6 py-3",
        className,
      )}
      style={style}
    >
      {isLoading ? <IcoSpinner className="!h-5 !w-5" /> : children}
    </button>
  );
}
